import _ from 'lodash';

export const handleSetState = (statePath: string, defaultValue: any = null) => (
  state: any,
  { payload },
) => {
  const oldValue = _.get(state, statePath, defaultValue);

  let newValue = payload;
  if (typeof oldValue === 'object') {
    newValue = { ...oldValue, ...payload };
  }
  return {
    ...state,
    ..._.set(state, statePath, newValue),
  };
};
